<div>
  <section class="row" style="margin-left: 0">
    <div class="col-2 header-subtitle-admin">
      <h2>{{''|i18n:'model-groups'}}</h2>
    </div>
    <div class="col-10">
      <button style="float: right; margin-top: 7px" (click)="addModelGroup()">{{''|i18n:'create-model-group'}}</button>
    </div>
  </section>

  <section class="col-12" style="margin-left: 30px">
    <div class="row-cols-6">
      <label class="col-3">
        {{''|i18n:'search-make'}} :
      </label>
      <label class="col-3">
        {{''|i18n:'search-model-code'}} :
      </label>
    </div>
    <form [formGroup]="form" class="row-cols-6">
      <select class="col-3" formControlName="make" (change)="search()">
        <option [value]="null">{{''| i18n:'select'}}</option>
        @for (make of brands; track make) {
          <option [ngValue]="make.name">{{make.name}}</option>
        }
      </select>
      <input formControlName="code" [placeholder]="''|i18n:'search'" class="col-3">
      <button (click)="search()" style="padding-bottom: 0"><i class="fa fa-search"></i></button>
      <button (click)="clear()" style="padding-bottom: 0"><i class="fa fa-times" ></i></button>
    </form>
  </section>
  <section class="row" style="margin-left: 60px; margin-top: 50px;">
    @if (modelGroups.length>0) {
      <table class="table-header">
        <thead>
          <tr class="row">
            <th class="col-3">{{''|i18n:'code'}}</th>
            <th class="col-3">{{''|i18n:'description'}}</th>
            <th class="col-3">{{''|i18n:'make'}}</th>
            <th class="col-3">{{''|i18n: 'action'}}</th>
          </tr>
        </thead>
      </table>
    }
    @for (modelGroup of modelGroups; track modelGroup) {
      <app-model-group-item class="col-12" [brands]="brands" [modelGroup]="modelGroup"
        (atModelGroup)="clearOne(modelGroup)"
      ></app-model-group-item>
    }
  </section>
</div>
<hr/>
<hr>
